<template>
	<div id="reconsentModal" class="modal" tabindex="-1" role="dialog" :class="{ show: showModal }">
		<div class="modal-dialog" :class="{ show: showModal }">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title">{{ $t('navigation.modal.reconsentTitle') }}</h4>
				</div>

				<div class="modal-body">{{ $t('navigation.modal.reconsentDesc') }}</div>

				<div class="modal-footer">
					<FormButton
						id="reconsentModalButton"
						class="btn-black btn-primary"
						:label="$t('navigation.modal.reconsentConfirm')"
						:button-click="confirmFunction"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { FormButton } from '@arena/toolkit';

export default {
	name: 'ReconsentModal',
	components: {
		FormButton,
	},
	props: {
		showModal: {
			type: Boolean,
			default: false,
		},
		confirmFunction: {
			type: Function,
			default: null,
		},
	},
};
</script>

<style lang="less" scoped>
@import '~@arena/toolkit/src/less/toolkit/toolkit.less';

.modal {
	display: none;
	font-size: 14px;
	line-height: 2em;
	.alert {
		position: relative !important;
		animation: none !important;
	}
	&.show {
		display: flex !important;
		align-items: center;
	}
	.modal-title,
	.modal-body,
	.modal-footer {
		user-select: none;
		&.show {
			animation: slide-down 0.3s ease-out;
			@keyframes slide-down {
				0% {
					opacity: 0;
					-webkit-transform: translateY(-100%);
				}
				100% {
					opacity: 1;
					-webkit-transform: translateY(0);
				}
			}
		}
	}
	.modal-body {
		color: #737373;
		white-space: pre-line;
	}
	.btn-block {
		margin-top: 0;
	}
	.submit-button-group {
		margin-top: -10px;
	}
}
</style>
